import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import { getAppConfig } from '../../config/config';
import { prepareAuthHeaders } from '../../config/authConfig';
import { SupportWidth } from 'types/domainTypes';

export const supportWidthsApi = createApi({
  reducerPath: 'supportWidthsApi',
  baseQuery: fetchBaseQuery({ prepareHeaders: prepareAuthHeaders }),
  tagTypes: ['SupportWidths'],
  endpoints: (builder) => ({
    getSupportWidths: builder.query<SupportWidth[], null>({
      query: () => {
        const url = `${getAppConfig().apiUrl}/supportwidths`;

        return { url: url, method: 'GET' };
      },
    }),
  }),
});

export const { useGetSupportWidthsQuery, util } = supportWidthsApi;
